/* eslint-disable import/first, import/newline-after-import */

import 'init/session-modal.css';

import(/* webpackMode: "eager" */ 'components/sessions/login-form/login-form');
import(/* webpackMode: "eager" */ 'components/sessions/registration-form/registration-form');
import(/* webpackMode: "eager" */ 'components/sessions/reset-password-form/reset-password-form');
import(/* webpackChunkName: 'update-password-form', webpackPrefetch: true */ 'components/sessions/update-password-form/update-password-form');
import(/* webpackChunkName: 'join-newsletter', webpackPrefetch: true */ 'components/sessions/join-newsletter/join-newsletter');

import(/* webpackChunkName: 'signup-survey', webpackPrefetch: true */ 'components/sessions/signup-survey/signup-survey');
import(/* webpackChunkName: 'email-verification', webpackPrefetch: true */ 'components/sessions/email-verification/email-verification');

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import(/* webpackChunkName: "modal-controller", webpackPreload: true */ 'layouts/modal/modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('ez-modal', controller.default);
  });

import(/* webpackChunkName: "account-form-controller" */ 'components/sessions/registration-form/account-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('registrations-account-form', controller.default);
  });

import(/* webpackChunkName: "details-form-controller" */ 'components/sessions/registration-form/details-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('registrations-details-form', controller.default);
  });

import(/* webpackChunkName: "login-form-controller" */ 'components/sessions/login-form/login-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('login-form', controller.default);
  });

import(/* webpackChunkName: "reset-password-form-controller", webpackPrefetch: true */ 'components/sessions/reset-password-form/reset-password-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('reset-password-form', controller.default);
  });

import(/* webpackChunkName: "signup-modal-controller" */ 'components/sessions/signup-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('signup-modal', controller.default);
  });

import(/* webpackChunkName: "signup-survey-modal-controller" */ 'components/sessions/signup-survey/signup-survey-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('signup-survey-modal', controller.default);
  });

import(/* webpackChunkName: "signup-survey-form-controller" */ 'components/sessions/signup-survey/signup-survey-form-controller')
  .then((controller) => {
    EezyStimulusApplication.register('signup-survey-form', controller.default);
  });

import(/* webpackChunkName: "email-verification-modal-controller" */ 'components/sessions/email-verification/email-verification-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('email-verification-modal', controller.default);
  });

import(/* webpackChunkName: "email-verified-modal-controller", webpackPrefetch: true */ 'components/sessions/email-verification/email-verified-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('email-verified-modal', controller.default);
  });

import(/* webpackChunkName: "google-one-tap-controller" */ 'components/sessions/google-one-tap/google-one-tap-controller')
  .then((controller) => {
    EezyStimulusApplication.register('google-one-tap', controller.default);
  });

import RecaptchaController from 'components/util/recaptcha/recaptcha-controller';
EezyStimulusApplication.register('recaptcha', RecaptchaController);

import SocialSessionButtonsController from 'components/sessions/social-session-buttons/social-session-buttons-controller';
EezyStimulusApplication.register('social-session-buttons', SocialSessionButtonsController);
